import React from "react";
import { useWorkflowCheckpointStore } from "../../../store";
import {
  Documentos,
  PanelExterior,
  SelloNaviera,
  SellosSalidaExporbananas,
  SellosSalidaVerificadora,
  Siglas,
} from "./components";
import { Input } from "antd";
import { PanelExteriorReInspeccion } from "./components/libs/panel-exterior-re-component";
import type { CollapseProps } from "antd";
import { Collapse, ConfigProvider } from "antd";
import { Box } from "@mui/material";

const { TextArea } = Input;

interface ThirdComponentPropsI {
  width: string;
  activeKey: any;
  setActiveKey: (key: any) => void;
}

export const ThirdComponent = React.memo(
  ({ width, activeKey, setActiveKey }: ThirdComponentPropsI) => {
  
    const items: CollapseProps["items"] = [
      {
        key: "1",
        label: (
          <p style={{ color: "navy", fontWeight: "bolder", fontSize: 12 }}>
            SIGLAS
          </p>
        ),
        children: <Siglas block={false} width={width} />,
      },
      {
        key: "2",
        label: (
          <p style={{ color: "navy", fontWeight: "bolder", fontSize: 12 }}>
            SELLOS VERIFICADORA
          </p>
        ),
        children: <SellosSalidaVerificadora widthFull={width} />,
      },
      {
        key: "3",
        label: (
          <p style={{ color: "navy", fontWeight: "bolder", fontSize: 12 }}>
            SELLOS EXPORTADOR
          </p>
        ),
        children: <SellosSalidaExporbananas widthFull={width} />,
      },
      {
        key: "4",
        label: (
          <p style={{ color: "navy", fontWeight: "bolder", fontSize: 12 }}>
            SELLO NAVIERA
          </p>
        ),
        children: <SelloNaviera widthFull={width} />,
      },
      {
        key: "5",
        label: (
          <p style={{ color: "navy", fontWeight: "bolder", fontSize: 12 }}>
            PANEL EXTERIOR
          </p>
        ),
        children: <PanelExterior widthFull={width} />,
      },
      {
        key: "6",
        label: (
          <p style={{ color: "navy", fontWeight: "bolder", fontSize: 12 }}>
            DOCUMENTOS
          </p>
        ),
        children: <Documentos />,
      },
      {
        key: "7",
        label: (
          <p style={{ color: "navy", fontWeight: "bolder", fontSize: 12 }}>
            PANEL EXTERIOR REINSPECCION
          </p>
        ),
        children: <PanelExteriorReInspeccion />,
      },
    ];

    return (
      <Box
        sx={{
          minHeight: `calc(100vh - 120px)`,
          maxHeight: `calc(100vh - 120px)`,
          height: `calc(100vh - 120px)`,
          overflowY: "auto",
          margin: 0,
          overflowX: "hidden",
          position: "relative",
          pt: 5,
        }}
      >
        <ConfigProvider
          theme={{
            components: {
              Collapse: {
                contentPadding: "0px",
              },
            },
            token: {
              motionDurationSlow: "0.1s",
              motionDurationMid: "0.1s",
            },
          }}
        >
          <Collapse
            style={{
              width: "100%",
              minWidth: "100%",
            }}
            accordion={true}
            expandIconPosition="end"
            items={items}
            bordered={false}
            destroyInactivePanel={true}
            activeKey={activeKey}
            onChange={(key: string[] | string) => {
              setActiveKey!(key as string[]);
            }}
          />
        </ConfigProvider>
       <Observation width={width} />
      </Box>
    );
  }
);

const Observation = ({ width }: { width: string }) => {
  const observation = useWorkflowCheckpointStore(
    (state) => state.observation
  );
  const setObservation = useWorkflowCheckpointStore(
    (state) => state.setObservation
  );

  return (
    <div style={{ padding: "10px" }}>
    <TextArea
      value={observation || ""}
      onChange={(e) => {
        setObservation(e.target.value);
      }}
      style={{ width: "100%", margin: "5px 0px 5px 0px" }}
      placeholder="Observación"
      rows={4}
    />
  </div>
  )
}
